import {ProgressStepProps} from '../model/types';

const STEP_SUBTITLES: Record<number, string> = {
  1: 'Draw partners attention',
  2: 'Start collaborating',
  3: 'Explore all features',
};

export const ProgressStep = ({step, title, isActive, isCompleted}: ProgressStepProps) => {
  return (
    <div className={`progress-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
      <div className="step-indicator">
        <div className="step-circle">{isCompleted ? <i className="pi pi-check"></i> : step}</div>
      </div>
      <div className="step-content">
        <span className="step-title">{title}</span>
        <span className="step-subtitle">{STEP_SUBTITLES[step] || ''}</span>
      </div>
    </div>
  );
};
